import { DialogContent, DialogContentProps } from '@mui/material';


import { makeStyles } from 'tss-react/mui';


const useStyles = makeStyles<ModalFullPageContentProps>()((theme) => ({
  root: {
    flex: 1,
    padding: theme.spacing(3, 2),
  },
}));


export type ModalFullPageContentProps = DialogContentProps;


export const ModalFullPageContent: React.FC<ModalFullPageContentProps> = (props) => {
  const { classes } = useStyles(props, { props: { classes: props.classes } });

  return (
    <DialogContent
      {...props}
      classes={classes}
    />
  );
};


ModalFullPageContent.displayName = 'ModalFullPageContent';
